import { useTranslation } from "react-i18next";
import {
  DeleteFilled,
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  MoreOutlined,
  SaveOutlined,
  SettingOutlined,
  UploadOutlined,
  WechatWorkOutlined
} from "@ant-design/icons";
import { Button, Dropdown, message, Modal, Space, Tooltip, } from "antd";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
  deleteCourseSequence,
  publishSequence,
  saveTemplateToLibrary,
} from "../../../../service/course-construct";
import { globalStore } from "../../../../stores/stores";
import { handleDownloadMoocsFile } from "../../../../utils/exportMoocsFile";
import AddChapter from "../../../drawer/add-chapter/AddChapter";
import AddLearningMaterialsReferences from "../../../drawer/add-learning-materials-references/AddLearningMaterialsReferences";
import AddLearningMaterials from "../../../drawer/add-learning-materials/AddLearningMaterials";
import AddLessionDrawer from "../../../drawer/add-lesstion";
import ImportMoocsFile from "../../../import-mooc-file/ImportMoocsFile";
import AddLessionModal from "../../../modal/add-lession";
import AssignContentCreationLesson from "../../../modal/assign-content-creatation-lesson";
import ChooseLearningMaterialModal from "../../../modal/choose-learning-material/ChooseLearningMaterialModal";
import ActiveSettingsChaptersDrawer from "../../active-settings-chapters-drawer/ActiveSettingsChaptersDrawer";
import "../course-constructor/course-construct.scss";
import "./lesson-card.scss";

type IProp = {
  data?: any;
  dataConfig?: any;
  itemDetailChapter?: any;
  handleGetDetail?: any;
  id?: any;
  name?: string;
  // updateUnit: (idSection: number, idSequence: number, data: any) => void;
};

const imgPath = "/images/";

const LessonCard = (props: IProp) => {
  const { t } = useTranslation();
  const { dataConfig, data } = props;
  const [isOpenAddLessionMoldal, setIsOpenAddLessionMoldal] =
    useState<boolean>(false);
  const [isOpenAddLessionDrawer, setIsOpenAddLessionDrawer] =
    useState<boolean>(false);
  const [isOpenDrawerLesson, setIsOpenDrawerLesson] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isLesson, setIsLesson] = useState<boolean>(false);
  const [multimediaType, setMultimediaType] = useState<string>("");
  const [isAddLearningMaterials, setIsAddLearningMaterials] =
    useState<boolean>(false);
  const [isAddLearningMaterialsReferences, setIsAddLearningMaterialsReferences] =
    useState<boolean>(false);
  const [isOpenSettingDraw, setIsOpenSettingDrawer] = useState(false);
  const [isOpenAssignContentCreation, setIsOpenAssignContentCreation] = useState(false);
  const [isOpenSaveTemplateModal, setIsOpenSaveTemplateModal] = useState(false);
  const params = useParams();
  const { reload, setReload } = globalStore()
  const isScheduleByTeacher = dataConfig?.isScheduleByTeacher
  const tooltipRef = useRef<HTMLDivElement | null>(null);
  const [tooltipWidth, setTooltipWidth] = useState<number>(0);
  const [isOpenImportMoocsFile, setIsOpenImportMoocsFile] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false)

  const handleDeleteSequence = async () => {
    try {
      const response = await deleteCourseSequence(Number(props.data.id)).then(
        (result) => {
          props.handleGetDetail();
          message.success(t("Xóa bài giảng thành công", "Xóa bài giảng thành công"));
        }
      );
    } catch (error) {
    }
  };

  const { confirm } = Modal;

  const showConfirm = () => {
    confirm({
      title: (
        <div className="title-container">
          <div style={{ color: "red", fontSize: "20px" }}>
            <DeleteFilled />
          </div>
          <span>{t("Bạn muốn xóa bài giảng?", "Bạn muốn xóa bài giảng?")}</span>
        </div>
      ),
      icon: null,
      okText: t("Xác nhận", "Xác nhận"),
      cancelText: t("Hủy", "Hủy"),
      okType: "danger",
      onOk() {
        handleDeleteSequence();
      },
      onCancel() {
      },
    });
  };

  const confirmAddLession = () => {
    setIsOpenAddLessionMoldal(false);
    setIsOpenAddLessionDrawer(true);
  };

  const handleChangeMenuType = (type: any) => {
    if (type.includes("reference")) {
      setIsAddLearningMaterialsReferences(type !== "");

    } else {
      setIsAddLearningMaterials(type !== "");
    }
    setMultimediaType(type)
  }

  const handlePublishSequence = async (sequenceId: number) => {
    try {
      await publishSequence(sequenceId);
      setReload(!reload)
      message.success(t("Xuất bản bài giảng thành công!", "Xuất bản bài giảng thành công!"))
    } catch (err) { }
  }

  const handleSaveTemplate = async (data: any) => {
    setIsSaving(true)
    const payload = {
      id: props.data.id,
      type: "sequence",
      folderId: data.folderId || undefined
    }

    try {
      await saveTemplateToLibrary(payload)
      message.success(t("Lưu mẫu bài giảng thành công", "Lưu mẫu bài giảng thành công"))
      setTimeout(() => {
        setIsOpenSaveTemplateModal(false)
      }, 0);
    } catch (error) {

    }
    finally {
      setIsSaving(false)
    }
  }

  useEffect(() => {
    if (tooltipRef.current) {
      const width = tooltipRef.current.offsetWidth;
      setTooltipWidth(width);
    }
  }, [data?.name]);

  return (
    <>
      <div className="chapter-header">
        <div className="chapter-title"
        >
          <img
            className=""
            loading="eager"
            alt=""
            src={imgPath + "ic_projects.svg"}
          />
          <Tooltip title={data?.name}
            overlayStyle={{ maxWidth: tooltipWidth + 20 }}
          >
            <div className="lesson-name"
              ref={tooltipRef}
            >
              {data?.name}
            </div>
          </Tooltip>

        </div>

        <Space>
          {!props.data?.isPublished &&
            <a className="action-course" onClick={() =>
              Modal.confirm({
                title: t("Xuất bản bài giảng", "Xuất bản bài giảng"),
                content:
                  t("Bạn có muốn xuất bản bài giảng này?", "Bạn có muốn xuất bản bài giảng này?"),
                okText: t("Xác nhận", "Xác nhận"),
                cancelText: t("Huỷ", "Huỷ"),
                onOk: () => {
                  handlePublishSequence(Number(props.data.id))

                },
                onCancel() {
                  // Optional: Handle the cancel event
                },
              })
            }>
              <UploadOutlined />
            </a>
          }
          <Dropdown
            menu={{
              items: [
                {
                  key: "1",
                  label: t("Sửa bài giảng", "Sửa bài giảng"),
                  icon: <EditOutlined />,
                },
                {
                  key: "2",
                  label: t("Xóa bài giảng", "Xóa bài giảng"),
                  icon: <DeleteOutlined />,
                  danger: true,
                },
                {
                  key: "3",
                  label: t("Cài đặt hoạt động", "Cài đặt hoạt động"),
                  icon: <SettingOutlined />,
                },
                {
                  key: "4",
                  label: t("Phân công xây dựng nội dung", "Phân công xây dựng nội dung"),
                  icon: <WechatWorkOutlined />,
                },
                {
                  key: "5",
                  label: t("Lưu mẫu bài giảng", "Lưu mẫu bài giảng"),
                  icon: <SaveOutlined />,
                },
                {
                  key: "6",
                  label: t("Tải lên học liệu", "Tải lên học liệu"),
                  icon: <UploadOutlined />,
                },
                {
                  key: "7",
                  label: t("Tải xuống bài giảng", "Tải xuống bài giảng"),
                  icon: <DownloadOutlined />,
                },
              ],
              onClick: ({ key }) => {
                if (key === "1") {
                  setIsOpenDrawerLesson(true);
                  setIsLesson(true);
                  setIsEdit(true);
                }
                if (key === "2") {
                  showConfirm();
                }
                if (key === "3") {
                  setIsOpenSettingDrawer(true);
                  setIsLesson(true)
                }
                if (key === "4") {
                  setIsOpenAssignContentCreation(true);
                }
                if (key === '5') {
                  setIsOpenSaveTemplateModal(true)
                }
                if (key === "6") {
                  setIsOpenImportMoocsFile(true);
                }
                if (key === '7') {
                  handleDownloadMoocsFile(data?.id, "sequence", data?.name);
                }
              },
            }}
            placement="bottomRight"
          >
            <Button className="action-course">
              <MoreOutlined />
            </Button>
          </Dropdown>
        </Space>
      </div >
      {/* <div
        onClick={() => setIsOpenAddLessionMoldal(true)}
        className="add-container"
      >
        <div>+</div>
        {t("Thêm học liệu", "Thêm học liệu")}
      </div> */}

      < AddLessionModal
        open={isOpenAddLessionMoldal}
        title={t("Chọn học liệu", "Chọn học liệu")}
        closeIcon={true}
        okText={t("Xác nhận", "Xác nhận")}
        cancelText={t("Huỷ", "Huỷ")}
        icon={null}
        confirm={confirmAddLession}
        multimediaType={handleChangeMenuType}
        closeModal={() => setIsOpenAddLessionMoldal(false)}

      />
      < AddLessionDrawer
        isScheduleByTeacher={isScheduleByTeacher}
        open={isOpenAddLessionDrawer}
        onClose={() => setIsOpenAddLessionDrawer(false)}
        id={params?.id}
        sequenceId={Number(props.data.id)}
        parentName={props.name}
      />
      <AddChapter
        id={props.id}
        title="Basic Drawer"
        setIsOpenDrawer={setIsOpenDrawerLesson}
        open={isOpenDrawerLesson}
        handleDetail={props.handleGetDetail}
        itemDetail={props?.data}
        isLesson={isLesson}
        isEdit={isEdit}
      />
      <AddLearningMaterials
        id={props.id}
        sequenceId={props.data.id}
        title="Basic Drawer"
        setIsOpenDrawer={setIsAddLearningMaterials}
        open={isAddLearningMaterials}
        handleDetail={props.handleGetDetail}
        itemDetail={props?.data}
        isEdit={isEdit}
        multimediaType={multimediaType}
      />

      <AddLearningMaterialsReferences
        id={props.id}
        sequenceId={props.data.id}
        title="Basic Drawer"
        setIsOpenDrawer={setIsAddLearningMaterialsReferences}
        open={isAddLearningMaterialsReferences}
        handleDetail={props.handleGetDetail}
        itemDetail={props?.data}
        isEdit={isEdit}
        multimediaType={multimediaType}
      />
      <ActiveSettingsChaptersDrawer
        id={props.id}
        setIsOpened={setIsOpenSettingDrawer}
        open={isOpenSettingDraw}
        handleDetail={props.handleGetDetail}
        itemDetail={props?.data}
        itemDetailChapter={props.itemDetailChapter}
        isLesson={isLesson}
      />

      <AssignContentCreationLesson
        open={isOpenAssignContentCreation}
        handleClose={() => setIsOpenAssignContentCreation(false)}
        sequenceId={props?.data?.id}
      />

      {/* <SaveTemplateLessonModal
        open={isOpenSaveTemplateModal}
        handleClose={() => setIsOpenSaveTemplateModal(false)}
        codeLesson={params?.id}
        sequenceId={props?.data?.id}
      /> */}


      <ChooseLearningMaterialModal
        open={isOpenSaveTemplateModal}
        onCancel={() => setIsOpenSaveTemplateModal(false)}
        mode="saveTemplate"
        onSaveTemplate={(data) => {
          handleSaveTemplate(data)
        }}
        isSaving={isSaving}
      />
      <ImportMoocsFile
        parentId={data?.id}
        type="unit"
        isOpenImportMoocsFile={isOpenImportMoocsFile}
        setIsOpenImportMoocsFile={setIsOpenImportMoocsFile}
      />
    </>
  );
};

export default LessonCard;
